import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";

interface ExpressInterestDialogProps {
  open: boolean;
  onClose: () => void;
  dealName: string;
  interestChoice: string;
  onInterestChoiceChange: (value: string) => void;
  onSubmit: () => void;
}

const ExpressInterestDialog: React.FC<ExpressInterestDialogProps> = ({
  open,
  onClose,
  dealName,
  interestChoice,
  onInterestChoiceChange,
  onSubmit,
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Express Interest in Deal</DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          Are you interested in this deal: {dealName}?
        </Typography>
        <RadioGroup
          value={interestChoice}
          onChange={(e) => onInterestChoiceChange(e.target.value)}
        >
          <FormControlLabel value="interested" control={<Radio />} label="Interested" />
          <FormControlLabel value="not_interested" control={<Radio />} label="Not Interested" />
        </RadioGroup>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" color="error" startIcon={<CloseIcon />} sx={{ borderRadius: 2, fontWeight: 600 }}>
          Cancel
        </Button>
        <Button onClick={onSubmit} variant="contained" color="primary" sx={{ borderRadius: 2, fontWeight: 600 }} startIcon={<SaveIcon />}>
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ExpressInterestDialog;
